import React, { useEffect, useMemo, useState } from 'react';

import { toggleProductImageZoomModal } from '@/redux/slices/gui.slice';

import { useAppDispatch, useAppSelector } from '@/redux';
import { buildCarouselContent, getAttributeId } from '@/utils/productUtils';

import TagDS from '@/components/common/ds-tag/Tag.ds';
import VideoESpot from '@/components/layout/espots/VideoESpot';
import HeaderProductImage from '@/components/product/HeaderProductImage';
import ProductImage from '@/components/product/ProductImage';

import styles from './ProductBonusDesktop.module.scss';
import { BONUS_TYPES } from '@/constants/product';
import { DEFAULT_RESOLUTION } from '@/constants/gui';
import { URLS } from '@/constants/urls';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import ReassuranceDesktop from '@/components/product/ReassuranceDesktop';

const ProductBonusDesktop = ({ product, currentItem, t }) => {
  const dispatch = useAppDispatch();
  const locale = useAppSelector(({ root }) => root.storeConf.locale);
  const reassurances = useAppSelector(({ root }) => root.storeConf.reassurances);
  const { isDesktop } = useScreenSizeContext();
  const itemImg = currentItem.image;
  const isAlert = getAttributeId(product, 'alerte_o_n') === '1';

  const images = useMemo(() => {
    return buildCarouselContent(product, undefined, false, itemImg);
  }, [product, itemImg]);

  const [selectedImage, setSelectedImage] = useState(images[0]);

  useEffect(() => {
    setSelectedImage(images[0]);
  }, [product, itemImg]);

  const handleClick = () => {
    dispatch(toggleProductImageZoomModal({ opened: true }));
  };

  const imgContainer = [
    styles['image-container'],
    product.mktOperation != null && styles.background
  ].filter(Boolean).join(' ');

  const backgroundImg = product.mktOperation && { backgroundImage: `url(${product.mktOperation.imgBgL})` };

  const photoCount = product.bonus?.length + 1;

  return images?.length > 0 ? (
    <div className={styles.container}>
      <div className={imgContainer} style={backgroundImg}>
        <HeaderProductImage product={product} />
        <div className={styles.image} onClick={handleClick}>
          {selectedImage.type === BONUS_TYPES.VIDEO ? (
            <VideoESpot
              data={selectedImage.value}
              lang={locale}
              withAutoplay
              isInCarousel
            />
          ) : (
            <ProductImage
              url={selectedImage.urlFull}
              alt={product.productName}
              sizeList={selectedImage.value === product.imageSize?._id ? product.imageSize?.sizeByFolder : null}
              size={DEFAULT_RESOLUTION}
              position={0}
              fetchPriority
            />
          )}
        </div>
        {photoCount > 1 && (
          <div className={styles['bonus-images']}>
            <TagDS
              onClick={handleClick}
              content={t('morePictures', { count: photoCount })}
              trailingContent={{ iconSrc: URLS.GALLERY, iconAlt: t('morePictures', { count: photoCount }) }}
              type="interactive" color="grey" cursor={URLS.ZOOM_IN}
            />
          </div>
        )}
      </div>
      {isDesktop && (
        <ReassuranceDesktop
          reassurances={reassurances}
          currentItem={currentItem}
          alertPrimeur={isAlert ? 'P' : ''}
        />
      )}
    </div>
  ) : null;
};

export default ProductBonusDesktop;
